import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PatientMenuSelectionEvent } from '../../interfaces/PatientMenuSelectionEvent';
import { PatientMenuRefreshEvent } from '../../interfaces/patient/PatientMenuRefreshEvent';
import { PatientMenuId, PatientMenuItemId } from '../../interfaces/PatientMenuId';
import { ViewOptionCategories } from '../../interfaces/ViewOptionCategories';
import { ActiveMenuContext, UpdateMenuContextEvent } from '../../interfaces/ActiveMenuContext';

@Injectable({
  providedIn: 'root'
})
export class PatientNavService {
  readonly patientMenuSelectionSubject = new Subject<PatientMenuSelectionEvent>();
  readonly patientMenuSelection$ = this.patientMenuSelectionSubject.asObservable();

  readonly activeMenuContextSubject = new BehaviorSubject<ActiveMenuContext | null>(null);
  readonly activeMenuContext$ = this.activeMenuContextSubject.asObservable();

  private readonly refreshMenuSubject = new Subject<PatientMenuRefreshEvent>();
  readonly refreshMenu$ = this.refreshMenuSubject.asObservable();

  readonly patientViewOptionSubject = new BehaviorSubject<UpdateMenuContextEvent | null>(null);
  readonly patientViewOption$ = this.patientViewOptionSubject.asObservable();

  onMenuItemSelect(patientMenuSelectionEvent: PatientMenuSelectionEvent): void {
    this.patientMenuSelectionSubject.next(patientMenuSelectionEvent);
  }

  setActiveMenuContext(context: ActiveMenuContext) {
    this.activeMenuContextSubject.next(context);
  }

  notifyMenuRefresh(refreshEvent: PatientMenuRefreshEvent): void {
    this.refreshMenuSubject.next(refreshEvent);
  }

  public getInitialCategoryId(categoryId: string): PatientMenuId {
    switch (categoryId) {
      case ViewOptionCategories.ALL:
        return PatientMenuItemId.REVIEW_PAST_NOTES_ALL;
      case ViewOptionCategories.VISIT_NOTES:
        return PatientMenuItemId.REVIEW_PAST_NOTES_VISIT_NOTES;
      case ViewOptionCategories.MESSAGES:
        return PatientMenuItemId.REVIEW_PAST_NOTES_MESSAGES;
      case ViewOptionCategories.ATTACHMENTS:
        return PatientMenuItemId.REVIEW_PAST_NOTES_ATTACHMENTS;
      case ViewOptionCategories.RESULTS:
        return PatientMenuItemId.REVIEW_PAST_NOTES_RESULTS;
      case ViewOptionCategories.EPISODES_OF_CARE:
        return PatientMenuItemId.REVIEW_PAST_NOTES_EPISODES_OF_CARE;
      default:
        return PatientMenuItemId.REVIEW_PAST_NOTES_ALL;
    }
  }

  public getRPNCategoryId(patientMenuId: PatientMenuId): ViewOptionCategories {
    switch (patientMenuId) {
      case PatientMenuItemId.REVIEW_PAST_NOTES_ALL:
        return ViewOptionCategories.ALL;
      case PatientMenuItemId.REVIEW_PAST_NOTES_VISIT_NOTES:
        return ViewOptionCategories.VISIT_NOTES;
      case PatientMenuItemId.REVIEW_PAST_NOTES_MESSAGES:
        return ViewOptionCategories.MESSAGES;
      case PatientMenuItemId.REVIEW_PAST_NOTES_ATTACHMENTS:
        return ViewOptionCategories.ATTACHMENTS;
      case PatientMenuItemId.REVIEW_PAST_NOTES_RESULTS:
        return ViewOptionCategories.RESULTS;
      default:
        return ViewOptionCategories.ALL; // You can adjust the default case if necessary
    }
  }

}
